/**
 * Toast types
 */
export enum EdpToastType {
    success = "success",
    info    = "info",
    warning = "warning",
    error   = "error",
    danger  = "danger"
}
